"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    iconStyles: function() {
        return iconStyles;
    },
    labelStyles: function() {
        return labelStyles;
    },
    inputGroupStyles: function() {
        return inputGroupStyles;
    },
    getInputGroupStyle: function() {
        return getInputGroupStyle;
    },
    getLabelStyle: function() {
        return getLabelStyle;
    },
    getIconStyle: function() {
        return getIconStyle;
    },
    flushedStyle: function() {
        return flushedStyle;
    },
    Input: function() {
        return Input;
    }
});
var _styles = require("../styles");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var textStyles = {
    large: "text-body-regular",
    medium: "text-body-regular",
    small: "text-body-meta-regular"
};
var iconContainerStyles = {
    large: {
        padding: "0.75rem 1rem"
    },
    medium: {
        padding: "0.625rem 0.75rem"
    },
    small: {
        padding: "0.625rem 0.75rem"
    }
};
var iconStyles = {
    disabled: {
        color: "text-disabled"
    },
    withContent: {
        color: "text-primary"
    }
};
var fieldSpacing = {
    large: {
        paddingLeft: "3rem"
    },
    medium: {
        paddingLeft: "2.5rem"
    },
    small: {
        paddingLeft: "2.5rem"
    }
};
var labelStyles = {
    backgroundColor: "background-static",
    transitionProperty: "var(--chakra-transition-property-common)",
    transitionDuration: "var(--chakra-transition-duration-normal)",
    sizes: {
        large: {
            paddingX: "1rem",
            paddingY: "0.75rem"
        },
        medium: {
            paddingX: "1rem",
            paddingY: "0.5rem"
        },
        small: {
            paddingX: "0.75rem",
            paddingY: "0.375rem"
        }
    },
    variants: {
        outline: {
            invalid: {
                boxShadow: "0 0 0 0.0625rem var(--chakra-colors-alert-error-default)",
                border: "0px solid transparent",
                borderColor: "transparent",
                position: "relative",
                zIndex: 1
            },
            disabled: {
                color: "text-disabled",
                borderColor: "ui-element-outline-disabled",
                border: "solid 0.0625rem var(--chakra-colors-ui-element-outline-disabled)"
            },
            hovered: {
                borderColor: "ui-element-outline-active"
            }
        },
        flushed: {
            invalid: {},
            disabled: {},
            hovered: {}
        }
    }
};
var inputGroupStyles = {
    outline: {
        invalid: {
            boxShadow: "0 0 0 0.125rem var(--chakra-colors-alert-error-default)",
            border: "0px solid transparent",
            borderColor: "transparent"
        },
        focused: {
            boxShadow: "0 0 0 0.1875rem var(--chakra-colors-primary-focus)"
        }
    },
    flushed: {
        invalid: {
            boxShadow: "0 0.125rem 0 0 var(--chakra-colors-alert-error-default)",
            border: "0px solid transparent",
            borderColor: "transparent",
            borderRadius: 0
        },
        focused: {
            boxShadow: "0 0.1875rem 0 0 var(--chakra-colors-primary-focus)",
            borderRadius: 0
        },
        hovered: {}
    }
};
var calculateSize = function(size) {
    var inputSizeHeight = {
        small: "2rem",
        medium: "2.5rem",
        large: "3rem"
    };
    return function(props) {
        return {
            elementContainer: _object_spread({}, iconContainerStyles[size]),
            leftLabel: _object_spread({}, labelStyles.sizes[size], props.theme.textStyles[textStyles[size]]),
            rightLabel: _object_spread({}, labelStyles.sizes[size], props.theme.textStyles[textStyles[size]]),
            field: _object_spread_props(_object_spread({}, props.theme.textStyles[textStyles[size]], _styles.inputStyles[size]), {
                height: inputSizeHeight[size],
                withIcon: _object_spread({}, fieldSpacing[size]),
                _placeholder: _object_spread({}, props.theme.textStyles[textStyles[size]])
            })
        };
    };
};
var sizes = {
    l: calculateSize("large"),
    m: calculateSize("medium"),
    s: calculateSize("small")
};
var getInputGroupStyle = function(props) {
    var variant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "outline";
    if (props.isInvalid) {
        return inputGroupStyles[variant].invalid;
    }
    if (props.isFocused) {
        return inputGroupStyles[variant].focused;
    }
    return {};
};
var getLabelStyle = function(props) {
    var variant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "outline";
    if (props.isInvalid) {
        return labelStyles.variants[variant].invalid;
    }
    if (props.isDisabled) {
        return labelStyles.variants[variant].disabled;
    }
    if (props.isHovered) {
        return labelStyles.variants[variant].hovered;
    }
    return {};
};
var getIconStyle = function(props) {
    if (props.isDisabled) {
        return iconStyles.disabled;
    }
    if (props.hasContent) {
        return iconStyles.withContent;
    }
    return {};
};
var fieldDisabledStyle = {
    opacity: 1,
    _placeholder: {
        color: "text-disabled"
    },
    color: "text-secondary",
    backgroundColor: "background-action-disabled",
    borderWidth: "0.0625rem",
    borderStyle: "solid",
    borderColor: "ui-element-outline-disabled"
};
var outlineStyle = function(props) {
    var inputGroupConditionalStyle = getInputGroupStyle(props);
    var labelConditionalStyle = getLabelStyle(props);
    var iconConditionalStyle = getIconStyle(props);
    return {
        inputGroup: _object_spread({
            transitionProperty: "var(--chakra-transition-property-common)",
            transitionDuration: "var(--chakra-transition-duration-normal)",
            borderRadius: "0.375rem"
        }, inputGroupConditionalStyle),
        leftLabel: _object_spread_props(_object_spread({}, labelStyles, labelConditionalStyle), {
            borderLeftRadius: "0.375rem"
        }),
        rightLabel: _object_spread_props(_object_spread({}, labelStyles, labelConditionalStyle), {
            borderRightRadius: "0.375rem"
        }),
        element: _object_spread({
            color: "text-secondary"
        }, iconConditionalStyle),
        elementContainer: {
            height: "100%"
        },
        field: {
            borderRadius: "0.375rem",
            color: "text-primary",
            backgroundColor: "background-action-default",
            borderWidth: "0.0625rem",
            borderStyle: "solid",
            borderColor: "ui-element-outline-default",
            _placeholder: {
                color: "text-disabled",
                textStyle: "text-body-regular"
            },
            _hover: {
                backgroundColor: "background-action-hover",
                borderWidth: "0.0625rem",
                borderStyle: "solid",
                borderColor: "ui-element-outline-active"
            },
            _focusVisible: {
                boxShadow: "none",
                borderWidth: "0.0625rem",
                borderStyle: "solid",
                borderColor: "ui-element-outline-default"
            },
            _invalid: {
                boxShadow: "none",
                border: "none",
                borderColor: "transparent"
            },
            _disabled: _object_spread_props(_object_spread({}, fieldDisabledStyle), {
                _hover: fieldDisabledStyle
            })
        }
    };
};
var flushedStyle = function(props) {
    var inputGroupConditionalStyle = getInputGroupStyle(props, "flushed");
    var labelConditionalStyle = getLabelStyle(props, "flushed");
    var iconConditionalStyle = getIconStyle(props);
    return {
        inputGroup: _object_spread({
            borderRadius: 0
        }, inputGroupConditionalStyle),
        leftLabel: _object_spread({}, labelStyles, labelConditionalStyle),
        rightLabel: _object_spread({}, labelStyles, labelConditionalStyle),
        element: _object_spread({
            color: "text-secondary"
        }, iconConditionalStyle),
        elementContainer: {
            height: "100%"
        },
        field: {
            color: "text-primary",
            backgroundColor: "background-action-default",
            border: "none",
            borderColor: "ui-element-outline-default",
            borderRadius: 0,
            _placeholder: {
                color: "text-disabled",
                textStyle: "text-body-regular"
            },
            _hover: {
                backgroundColor: "background-action-hover",
                border: "none",
                borderBottom: "0.0625rem solid var(--chakra-colors-ui-element-outline-active)"
            },
            _focusVisible: {
                boxShadow: "none",
                border: "none",
                borderBottom: "solid 0.0625rem var(--chakra-colors-ui-element-outline-default)",
                borderColor: "ui-element-outline-default"
            },
            _invalid: {
                boxShadow: "none",
                border: "none",
                borderColor: "transparent"
            },
            _disabled: _object_spread_props(_object_spread({}, fieldDisabledStyle), {
                _hover: fieldDisabledStyle
            })
        }
    };
};
var Input = {
    parts: [
        "element",
        "elementContainer",
        "inputGroup",
        "field",
        "leftLabel",
        "rightLabel"
    ],
    baseStyle: {
        field: {
            border: "none",
            _hover: {
                boxShadow: "none",
                border: "none"
            },
            _focusVisible: {
                boxShadow: "none",
                border: "none"
            }
        }
    },
    defaultProps: {
        size: "m",
        variant: "outline"
    },
    sizes: sizes,
    variants: {
        outline: outlineStyle,
        flushed: flushedStyle
    }
};
